(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slideshow-media-label')) {
    customElements.define('slideshow-media-label', class extends HTMLElement {
      constructor() {
        super();
        this.scheduleFit = this.scheduleFit.bind(this);
      }

      connectedCallback() {
        this.resizeObserver = new ResizeObserver(this.scheduleFit);
        this.resizeObserver.observe(this);
        this.contentObserver = new MutationObserver(this.scheduleFit);
        this.contentObserver.observe(this, { childList: true, characterData: true, subtree: true });
        this.addEventListener('load', this.scheduleFit, true);
        window.addEventListener('resize', this.scheduleFit);
        document.fonts.addEventListener('loadingdone', this.scheduleFit);
        document.fonts.ready.then(this.scheduleFit);
        this.scheduleFit();
      }

      disconnectedCallback() {
        this.resizeObserver.disconnect();
        this.contentObserver.disconnect();
        this.removeEventListener('load', this.scheduleFit, true);
        window.removeEventListener('resize', this.scheduleFit);
        document.fonts.removeEventListener('loadingdone', this.scheduleFit);
        cancelAnimationFrame(this.fitFrame);
        this.fitFrame = null;
      }

      scheduleFit() {
        if (!this.isConnected || this.fitFrame) return;
        this.fitFrame = requestAnimationFrame(() => {
          this.fitFrame = null;
          this.fitText();
        });
      }

      fitFont(element, fits) {
        element.style.removeProperty('font-size');
        const maximum = parseFloat(getComputedStyle(element).fontSize);
        if (fits()) return;

        let minimum = 0;
        let upper = maximum;
        // Measure rendered lines so words, long strings and loaded fonts all fit.
        for (let step = 0; step < 14; step++) {
          const size = (minimum + upper) / 2;
          element.style.fontSize = `${size}px`;
          if (fits()) minimum = size;
          else upper = size;
        }
        element.style.fontSize = `${Math.floor(minimum * 1000) / 1000}px`;
      }

      fitText() {
        const box = this.getBoundingClientRect();
        if (!box.width || !box.height) return;

        const button = this.querySelector('.slideshow__media-label-button');
        const buttonText = this.querySelector('.slideshow__media-label-button-text');
        if (button && buttonText) {
          const buttonStyle = getComputedStyle(button);
          const availableHeight = button.clientHeight - parseFloat(buttonStyle.paddingTop) - parseFloat(buttonStyle.paddingBottom);
          this.fitFont(button, () => buttonText.scrollHeight <= availableHeight + .5 && buttonText.scrollWidth <= buttonText.clientWidth + .5);
        }

        const description = this.querySelector('.slideshow__media-label-description');
        if (!description) return;
        const border = getComputedStyle(this, '::before');
        const radius = Math.min(box.width, box.height) / 2 - parseFloat(border.top) - parseFloat(border.borderTopWidth) - 1;
        const centerX = box.left + box.width / 2;
        const centerY = box.top + box.height / 2;
        const range = document.createRange();
        range.selectNodeContents(description);

        this.fitFont(description, () => {
          if (description.scrollHeight > description.clientHeight + .5 || description.scrollWidth > description.clientWidth + .5) return false;
          // Check the actual lines against the round border, including their corners.
          return Array.from(range.getClientRects()).every(line => {
            const x = Math.max(Math.abs(line.left - centerX), Math.abs(line.right - centerX));
            const y = Math.max(Math.abs(line.top - centerY), Math.abs(line.bottom - centerY));
            return Math.hypot(x, y) <= radius;
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
